$(function () {
	$('a[href*=\\#]:not([href=\\#])').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				if ($(this).parents('.menuBox').length) {
					setTimeout(function () {
						var targetOffset = $target.offset().top - $('#gHeader').outerHeight();
						$('html,body').animate({ scrollTop: targetOffset }, 1000);
					}, 100);
				} else {
					var targetOffset = $target.offset().top - $('#gHeader').outerHeight();
					$('html,body').animate({ scrollTop: targetOffset }, 1000);
				}
				return false;
			}
		}
	});

	var state = false;
	var scrollpos;

	$('.menu').on('click', function () {
		if (state == false) {
			scrollpos = $(window).scrollTop();
			$('body').addClass('fixed').css({ 'top': -scrollpos });
			$(this).addClass('on');
			$('.menuBox').stop().fadeToggle();
			state = true;
		} else {
			$('body').removeClass('fixed').css({ 'top': 0 });
			window.scrollTo(0, scrollpos);
			$(this).removeClass('on');
			$('.menuBox').stop().fadeToggle();
			state = false;
		}
		return false;
	});

	$('.menuBox a:not(.accordion)').on('click', function () {
		if (window.innerWidth < 897) {
			$('body').removeClass('fixed').css({ 'top': 0 });
			window.scrollTo(0, scrollpos);
			$('.menu').removeClass('on');
			$('.menuBox').fadeOut();
			state = false;
		}
	});

	$("#gNavi .naviList li:has(.subList)").hover(function () {
		if (!$(this).hasClass('on') && window.innerWidth > 896) {
			$(this).addClass("on");
			$(this).find('.subList').stop().slideToggle();
		}
	}, function () {
		if ($(this).hasClass('on') && window.innerWidth > 896) {
			$(this).removeClass("on");
			$(this).find('.subList').stop().slideToggle();
		}
	});

	var pcflag, spflag;
	if (window.innerWidth > 896) {
		pcflag = 1;
		spflag = 0;
	} else {
		pcflag = 0;
		spflag = 1;
	}
	$(window).resize(function () {
		if (window.innerWidth <= 896) {
			if (pcflag) {
				setTimeout(function () {
					$('#gNavi .naviList .subList').hide();
				}, 100);
				pcflag = 0;
				spflag = 1;
			}
		} else {
			if (spflag) {
				setTimeout(function () {
					$('#gNavi .naviList .subList').hide();
				}, 100);
				pcflag = 1;
				spflag = 0;
			}
		}
	});

	$('#gNavi .naviList li .accordion, #gFooter .fNaviList li .accordion').on('click', function () {
		if (window.innerWidth < 897) {
			$(this).toggleClass('on').next().stop().slideToggle(300);
			return false;
		}
	});

	if ($('.a-upload').length) {
		$(".a-upload").each(function () {
			var th = $(this);
			$(this).find('input[type="file"]').change(function () {
				var filePath = $(this).val();
				if (filePath != '') {
					var arr = filePath.split('\\');
					var fileName = arr[arr.length - 1];
					th.children(".showFileName").html(fileName);
				} else {
					th.children(".showFileName").html("選択されていません");
					th.children(".fileerrorTip").html("ファイルを選択").show();
					return false
				}
			});
		});
	}

	if ($('.js-more').length) {
		$('.js-more-btn a').on('click', function () {
			$(this).parents('.js-more-btn').hide();
			$(this).parents('.js-more').find('.js-more-list').addClass('more');
			return false;
		});
	}

	$(window).on('scroll', function () {
		var windowHeight = $(window).height(),
			topWindow = $(window).scrollTop();
		$('.fadeIn, .fadeInRight, .fadeInUp').each(function () {
			var targetPosition = $(this).offset().top;
			if (topWindow > targetPosition - windowHeight + 100) {
				$(this).addClass("on");
			}
		});
	}).trigger('scroll');
});

$(window).on('load', function () {
	$(window).trigger('scroll');
	
	var localLink = window.location + '';
	if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
		localLink = localLink.slice(localLink.indexOf("#") + 1);
		if ($('#' + localLink).length) {
			setTimeout(function () {
				$('html,body').animate({ scrollTop: $('#' + localLink).offset().top - $('#gHeader').outerHeight() }, 500);
			}, 100);
		}
	}
});